import { GENERATE_UPLOAD_LINK_RESTART_PAYMENT_PACKAGE } from "..";
import { apiInstance } from "../config/apiInstance";

export type GenerateUploadLinkRestartPaymentPackageRequest = {
  fileName: string[];
};

export type UploadLinkResponse = {
  id: number;
  link: string;
  originalName: string;
};

export const generateUploadLinkRestartPaymentPackage = async (
  data: GenerateUploadLinkRestartPaymentPackageRequest,
): Promise<UploadLinkResponse[]> => {
  const response = await apiInstance.post<UploadLinkResponse[]>(
    GENERATE_UPLOAD_LINK_RESTART_PAYMENT_PACKAGE,
    data,
  );
  return response.data;
};
